import { useI18n } from 'builder/hooks/useI18n'
import { useTypedSelector } from 'builder/hooks/useTypedSelector'
import { PersonalEditorField } from './PersonalEditorField'

export const Address = () => {
  const { i18n } = useI18n()
  const address = useTypedSelector(state => state.resumeEditor.resume?.address)

  return (
    <>
      {/* Address */}
      <PersonalEditorField
        label={i18n.t('builder.resume_editor.address')}
        value={address || ''}
        name="address"
      />
    </>
  )
}
